import 'core-js/stable';
import 'regenerator-runtime/runtime';

window.process = {
    env: "PRODUCTION"
} as unknown as NodeJS.Process;